function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

import React, { PureComponent, createContext } from "react";
export var IndexContext = /*#__PURE__*/createContext();
var ids = -1;
export function withIndex(Cmp) {
  var WithIndex = /*#__PURE__*/function (_PureComponent) {
    _inheritsLoose(WithIndex, _PureComponent);

    function WithIndex(props) {
      var _this;

      _this = _PureComponent.call(this, props) || this;
      ids = ids + 1;
      _this.state = {
        id: ids,
        getID: _this.getID
      };
      return _this;
    }

    var _proto = WithIndex.prototype;

    _proto.getID = function getID() {
      return ++ids;
    };

    _proto.render = function render() {
      return /*#__PURE__*/React.createElement(IndexContext.Provider, {
        value: this.state
      }, /*#__PURE__*/React.createElement(Cmp, this.props));
    };

    return WithIndex;
  }(PureComponent);

  return WithIndex;
}